import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const WomanAndHome: Site = {
  id: 'womanandhome',
  logo: 'svg/womanandhome.svg',
  label: 'Woman and Home',
  analyticsName: 'womanandhome',
  hostname: 'womanandhome.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
